import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

export const useAutocompleteSession = () => {
  const [sessionToken, setSessionToken] = useState<string>(uuidv4())
  const refreshSessionToken = () => setSessionToken(uuidv4())
  return { sessionToken, refreshSessionToken }
}
